import { Util, Request } from "@xt/xtbase";

const { getOrigin } = Util;
const { XtAxios4 } = Request;

const SAPI_V4 = () => `${getOrigin("www")}/sapi/v4`;

function hyperpayTransactionUrl(path) {
  return `${SAPI_V4()}/payment/hyperpay/transaction${path}`;
}

/** HyperPay 卡种 ID（暂写死，后续改从 card/list 或 cardInfo 读取） */
export const HYPERPAY_CARD_TYPE_ID = "52400001";

function withPayCurrencyParams(config, payCurrency) {
  const normalized = payCurrency != null && String(payCurrency).trim() !== ""
    ? String(payCurrency).trim().toUpperCase()
    : "";
  if (!normalized) return config;
  return {
    ...config,
    params: {
      payCurrency: normalized,
      ...config?.params,
    },
  };
}

/** POST §四-12 充值反向估算（支付 USDT/BRL → 到账 USD） */
export function post_hyperpayEstimateCurrency(data, config) {
  const { payCurrency, ...restConfig } = config || {};
  return XtAxios4.post(
    hyperpayTransactionUrl("/estimate/currency"),
    {
      card_type_id: HYPERPAY_CARD_TYPE_ID,
      pay_coin: "usdt",
      ...data,
    },
    withPayCurrencyParams(
      {
        ...restConfig,
        isAutoPopError: false,
      },
      payCurrency
    )
  );
}

/** POST §四-11 充值费用估算（目标 USD → 需支付 USDT，含平台服务费） */
export function post_hyperpayEstimateCrypto(data, config) {
  const { payCurrency, ...restConfig } = config || {};
  return XtAxios4.post(
    hyperpayTransactionUrl("/estimate/crypto"),
    {
      card_type_id: HYPERPAY_CARD_TYPE_ID,
      pay_coin: "usdt",
      ...data,
    },
    withPayCurrencyParams(
      {
        ...restConfig,
        isAutoPopError: false,
      },
      payCurrency
    )
  );
}

/** GET §四-13 充值限额 */
export function get_hyperpayRechargeLimit(cardInfoId, config) {
  return XtAxios4.get(hyperpayTransactionUrl("/recharge/limit"), {
    ...config,
    params: { cardInfoId },
    isAutoPopError: false,
  });
}

/** POST §四-14 提交充值 */
export function post_hyperpayRecharge(data, config) {
  const { payCurrency, ...restConfig } = config || {};
  return XtAxios4.post(
    hyperpayTransactionUrl("/recharge"),
    {
      pay_coin: "usdt",
      ...data,
    },
    withPayCurrencyParams(
      {
        ...restConfig,
        isAutoPopError: false,
      },
      payCurrency
    )
  );
}

/** POST §四-15 充值结果查询 */
export function post_hyperpayRechargeQuery(data, config) {
  return XtAxios4.post(hyperpayTransactionUrl("/recharge/query"), data, {
    ...config,
    isAutoPopError: false,
  });
}

/** POST §五-16 交易记录列表 */
export function post_hyperpayTransactions(data, config) {
  return XtAxios4.post(hyperpayTransactionUrl("/transactions"), data, {
    ...config,
    isAutoPopError: false,
  });
}

/** POST §五-17 单笔交易详情（Query: txId, cardId） */
export function post_hyperpayTransactionDetail(params, config) {
  return XtAxios4.post(hyperpayTransactionUrl("/detail"), null, {
    ...config,
    params,
    isAutoPopError: false,
  });
}
